import { z } from 'zod';

const PublicAvailabilityIntervalSchema = z
  .object({
    availabilityDate: z.string(),
    shiftType: z.enum(['SHIFT', 'CALL']),
    startsAt: z.string(),
    endsAt: z.string(),
  })
  .strict();

export const PublicAvailabilitySelectionOptionSchema = z
  .object({
    availabilityDate: z.string(),
    detailMode: z.enum(['DATE_ONLY', 'SHIFT_DETAIL']),
    timezone: z.string().min(1),
    availabilityEntryIds: z.array(z.number().int().positive()).min(1),
    startsAt: z.string().nullable(),
    endsAt: z.string().nullable(),
    shiftLabel: z.enum(['DAY', 'EVENING', 'NIGHT', 'CUSTOM']).nullable(),
    shiftType: z.enum(['SHIFT', 'CALL']).nullable(),
    workLocation: z.enum(['REMOTE', 'ONSITE', 'PARTIAL_REMOTE']).nullable(),
    stateCode: z.string().nullable(),
  })
  .strict();

const PublicAvailabilityMatchSchema = z
  .object({
    dateMatch: z.enum(['date-only', 'exact']),
    matchingDates: z.array(z.string()),
    matchingDateCount: z.number().int().nonnegative(),
    matchingShiftLabels: z.array(z.enum(['DAY', 'EVENING', 'NIGHT', 'CUSTOM'])),
    matchingShiftTypes: z.array(z.enum(['SHIFT', 'CALL'])),
    mergedExactIntervals: z.array(PublicAvailabilityIntervalSchema),
    nextAvailableDate: z.string().nullable(),
    lastAvailabilityUpdateAt: z.string().nullable(),
    selectionOptions: z.array(PublicAvailabilitySelectionOptionSchema),
  })
  .strict();

export const ProviderServiceListingSearchItemSchema = z
  .object({
    providerServiceListingId: z.number().int().positive(),
    existingResponseId: z.number().int().positive().nullish(),
    listingTitle: z.string(),
    listingKind: z.string(),
    providerCategoryId: z.number().int().positive(),
    providerCategoryCode: z.string().nullable(),
    workLocation: z.enum(['REMOTE', 'ONSITE', 'PARTIAL_REMOTE']),
    specialties: z.array(z.string()),
    subspecialties: z.array(z.string()),
    generalSpecialtyFlag: z.boolean(),
    licenseStateCodes: z.array(z.string()),
    availability: PublicAvailabilityMatchSchema.nullable(),
  })
  .strict();

export const ProviderServiceListingSearchResponseSchema = z
  .object({
    data: z.array(ProviderServiceListingSearchItemSchema),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
  })
  .strict();

export type PublicAvailabilitySelectionOption = z.infer<
  typeof PublicAvailabilitySelectionOptionSchema
>;
export type ProviderServiceListingSearchItem = z.infer<
  typeof ProviderServiceListingSearchItemSchema
>;
export type ProviderServiceListingSearchResponse = z.infer<
  typeof ProviderServiceListingSearchResponseSchema
>;
